import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import LayersIcon from "@mui/icons-material/Layers";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Collapse, Divider } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import LogoutIcon from "@mui/icons-material/Logout";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AppShortcutIcon from "@mui/icons-material/AppShortcut";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import StorefrontIcon from "@mui/icons-material/Storefront";
import CategoryIcon from "@mui/icons-material/Category";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import DraftsIcon from "@mui/icons-material/Drafts";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import { clearAllLocalStorage } from "../../Utils/util-service";

function Navigation() {
  let urllocation = useLocation();
  const navigate = useNavigate();
  const [location, setLocation] = React.useState({});
  React.useEffect(() => {
    setLocation(urllocation);
  }, [urllocation]);
  const goTo = (path) => {
    navigate(path);
  };
  const [open, setOpen] = React.useState(false);
  const [openVendor, setOpenVendor] = React.useState(true);
  const [openStore, setOpenStore] = React.useState(true);
  const [openBanner, setOpenBanner] = React.useState(true);

  React.useEffect(() => {
    if (location.pathname?.startsWith("/banners")) {
      setOpenBanner(true);
    }
    if (location.pathname?.startsWith("/store")) {
      setOpenStore(true);
    }
  }, [location.pathname]);

  const logoutUser = () => {
    clearAllLocalStorage();
    goTo("/login");
  };
  return (
    <List component="nav">
      <React.Fragment>
        <ListItemButton
          selected={location.pathname === "/"}
          onClick={() => goTo("/")}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Estimates" />
        </ListItemButton>
        {/* <ListItemButton
          selected={location.pathname === "/estimates"}
          onClick={() => goTo("/estimates")}
        >
          <ListItemIcon>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText primary="Estimates" />
        </ListItemButton> */}
        <ListItemButton onClick={() => setOpenVendor(!openVendor)}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Vendors" />
          {openVendor ? <ExpandLessIcon /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openVendor} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              selected={location.pathname === "/vendors"}
              onClick={() => goTo("/vendors")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <FormatListNumberedIcon />
              </ListItemIcon>
              <ListItemText primary="Vendors List" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === "/vendors/create"}
              onClick={() => goTo("/vendors/create")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <EditNoteIcon />
              </ListItemIcon>
              <ListItemText color="primary" primary="Create Vendor" />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton onClick={() => setOpenStore(!openStore)}>
          <ListItemIcon>
            <StorefrontIcon />
          </ListItemIcon>
          <ListItemText primary="Store Management" />
          {openStore ? <ExpandLessIcon /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openStore} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              selected={location.pathname === "/store/inquired"}
              onClick={() => goTo("/store/inquired")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <ShoppingCartIcon />
              </ListItemIcon>
              <ListItemText primary="Inquired Products" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === "/store/out-of-stock"}
              onClick={() => goTo("/store/out-of-stock")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <Inventory2Icon />
              </ListItemIcon>
              <ListItemText primary="Out of Stock Products" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === "/store/draft"}
              onClick={() => goTo("/store/draft")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <DraftsIcon />
              </ListItemIcon>
              <ListItemText primary="Draft Products" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === "/store/categories"}
              onClick={() => goTo("/store/categories")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <CategoryIcon />
              </ListItemIcon>
              <ListItemText primary="Categories" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === "/store/unpublished-categories"}
              onClick={() => goTo("/store/unpublished-categories")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <UnpublishedIcon />
              </ListItemIcon>
              <ListItemText primary="Unpublished Categories" />
            </ListItemButton>
          </List>
        </Collapse>
        <ListItemButton onClick={() => setOpenBanner(!openBanner)}>
          <ListItemIcon>
            <AppShortcutIcon />
          </ListItemIcon>
          <ListItemText primary="Banners" />
          {openBanner ? <ExpandLessIcon /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openBanner} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              selected={location.pathname === "/banners"}
              onClick={() => goTo("/banners")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <ViewCarouselIcon />
              </ListItemIcon>
              <ListItemText primary="Primary Banner" />
            </ListItemButton>
            <ListItemButton
              selected={location.pathname === "/banners/secondary"}
              onClick={() => goTo("/banners/secondary")}
              sx={{ pl: 4 }}
            >
              <ListItemIcon>
                <ViewAgendaIcon />
              </ListItemIcon>
              <ListItemText primary="Secondary Banner" />
            </ListItemButton>
          </List>
        </Collapse>
        {/* 
        <ListItemButton>
          <ListItemIcon>
            <LayersIcon />
          </ListItemIcon>
          <ListItemText primary="Integrations" />
        </ListItemButton> */}
        {/* </React.Fragment>
      <React.Fragment> */}
        {/* <ListSubheader component="div" inset>
          Saved reports
        </ListSubheader>
        <ListItemButton>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Current month" />
        </ListItemButton>
        <ListItemButton>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Last quarter" />
        </ListItemButton> */}
        {/* <ListItemButton
          sx={{ position: "fixed", bottom: 0 }}
          disableRipple
          disableTouchRipple
        >
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary="Pawan Sancheti" />
        </ListItemButton> */}
        {/* <ListItemButton>
          <ListItemIcon>
            <AppShortcutIcon />
          </ListItemIcon>
          <ListItemText primary="App Settings" />
        </ListItemButton> */}
        <Divider sx={{ marginBottom: 8 }} />
        <ListItemButton onClick={() => setOpen(!open)}>
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary="Pawan Sancheti" />
          {open ? <ExpandLessIcon /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton onClick={logoutUser} sx={{ pl: 4 }}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItemButton>
          </List>
        </Collapse>
      </React.Fragment>
    </List>
  );
}

export default Navigation;
